import React from "react";
import { observer } from "mobx-react";
// import { useHistory } from "react-router-dom";

import "./style.scss";
// import { MemberTips } from "../index";
// import authStore from "../../../stores/authStore";
// import correspondenceStore from "../../../stores/correspondenceStore";
// import globalStore from "../../../stores/globalStore";
// import { isMobile, scanCb, removeQueryParams } from "../../../utils/tools";
// import { urlTranslate } from "../../../utils/wx_tools";
// import checkOrigin from "./checkOrigin";

interface Props {
  children: React.ReactNode;
}

const ArticleLayout: React.FC = (props: Props) => {
  const { children } = props;

  return (
    <div className="article-layout">
      <div className="article-layout__header">{children[0]}</div>
      <div className="article-layout__body">{children[1]}</div>
    </div>
  );
};

export default observer(ArticleLayout);
